import { Avatar, Card, Col, Flex, Layout, Row } from "antd";
import { useAppSelector } from "src/app/hooks";
import { selectUser } from "src/appRedux/reducers/userReducer";

import { UserOutlined } from "@ant-design/icons";

const HoSo = () => {
  const useInfo = useAppSelector(selectUser);
  const authuser = useInfo?.user || undefined;

  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h2 style={{ color: "black", fontSize: 20 }}>Thông tin tài khoản</h2>
        </Col>
      </div>
      <Card className="th-card-margin-bottom">
        <Flex gap="middle" align="start" vertical>
          <Flex justify={"space-between"} align={"flex-start"} gap={36}>
            <div>
              <Avatar
                alt=""
                icon={<UserOutlined />}
                size={70}
                style={{ marginRight: 5 }}
                shape="square"
              />
            </div>
            <Row gutter={24} style={{ padding: 25 }}>
              <Col md={8} xs={24}>
                <p>
                  <strong>Họ và tên:</strong> {authuser?.hoVaTen}
                </p>
              </Col>
              <Col md={8} xs={24}>
                <p>
                  <strong>Tài khoản:</strong> {authuser?.userName}
                </p>
              </Col>
              <Col md={8} xs={24}>
                <p>
                  <strong>Đơn vị:</strong> {authuser?.coQuan?.tenDonVi}
                </p>
              </Col>
              <Col md={8} xs={24}>
                <p>
                  <strong>Giới tính:</strong>
                  {authuser.gioiTinh ? "Nữ" : "Nam"}
                </p>
              </Col>
              <Col md={8} xs={24}>
                <p>
                  <strong>Địa chỉ:</strong> {authuser?.diaChi}
                </p>
              </Col>
              <Col md={8} xs={24}>
                <p>
                  <strong>Số điện thoại:</strong> {authuser?.dienThoai}
                </p>
              </Col>
            </Row>
          </Flex>
        </Flex>
      </Card>
    </Layout>
  );
};

export default HoSo;
